import React from "react";
import ProductItem from "./ProductItem";

const styles = {
  productList: {
    marginTop: 0,
    paddingLeft: 0,
  },
};

const ProductList = ({ market, getRates }) => {
  return (
    <ul style={styles.productList}>
      {market.name === "BÉT" ? (
        <li>Jelenleg nincs kereskedés</li>
      ) : (
        market.products.map((product, index) => (
          <ProductItem
            isCBOT={market.name === "CBOT"}
            product={product}
            city={market.city}
            key={`product-${index}`}
            getRates={getRates}
          />
        ))
      )}
    </ul>
  );
};

export default ProductList;
